import React, { useState, useEffect } from 'react';

const DivisionElement = ({ division, level, sel, setSel }) => {

    const fontSize = 16 - level;
    const padding = 40 * level;
    const label = `${division.Title}`;
    const border = sel && division.DivisionId === sel.DivisionId ? "1px solid red" : "0px solid red";
    return (
        <div>
            <p style={{ 'border': border, 'paddingLeft': padding, 'fontSize': fontSize }} onClick={() => setSel(division)}>{label}</p>
            {
                (division.Children || []).map((i, ix) => <DivisionElement division={i} level={level + 1} sel={sel} setSel={setSel} key={ix} />)
            }
        </div>
    )
}

export default DivisionElement;